import * as actionTypes from '../actions/actionTypes';


export default function rafPackDetails(state = {}, action) {
    switch(action.type){
      case actionTypes.SAVE_RAF_DETAILS:
      let newState = {...state};
      newState.savedRAFPack={
        newRAFPack : action.newRAFPack,
        isRAFPack:action.newRAFPack.isRafPack
      };
      return newState.savedRAFPack;
      case actionTypes.DELETE_RAF_DETAILS:
        newState = {...state};
      return newState.savedRAFPack={
        newRAFPack :null,
        isRAFPack:false
      };
      case actionTypes.PACK_NUMBER_NOT_FOUND:
        newState = {...state};
      return newState.savedRAFPack={
        status :action.status
      };


      default: return state;

    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/reducers/rafPackDetails.js